module.exports = __webpack_public_path__ + "img/Ströumgsrettungstrupp.5bd42b17.svg";